import React from 'react';
import Head from 'next/head';

interface FacebookProps {
  url: string;
  type?: string;
  title: string;
  desc: string;
  image: string;
  locale: string;
}

const Facebook = ({
  url,
  type = 'website',
  title,
  desc,
  image,
  locale,
}: FacebookProps) => (
  <Head>
    <meta key="og-locale" property="og:locale" content={locale} />
    <meta key="og-url" property="og:url" content={url} />
    <meta key="og-type" property="og:type" content={type} />
    <meta key="og-title" property="og:title" content={title} />
    <meta key="og-des" property="og:description" content={desc} />
    <meta key="og-image" property="og:image" content={image} />
    <meta key="og-image-alt" property="og:image:alt" content={desc} />
  </Head>
);

export default Facebook;
